export default class User {
	nickname!: string;
	name!: string;
	picture!: string;
	lastLogin!: string;
	email!: string;
}
